module.exports = __webpack_public_path__ + "static/media/icon_onboarding_arrow.dfe64ece.png";